import { c as _c } from "react/compiler-runtime";
import { useItemStagger } from "@website/widget/item-stagger/item-stagger.hook";
import { Fragment } from "react";
import { ListingBanners } from "./listing-banners";
import { ListingContainerBreakpoint, ListingContainerCols, ListingContainerPropertiesType, ListingContainerResponsiveCols } from "./listing-container.types";
import { ListingEmptyState } from "./listing-empty-state";
const GAP_X = {
  "4": "gap-x-4"
};
const GAP_Y = {
  "6": "gap-y-6"
};
const SKELETON_ITEMS_COUNT = 20;
const colClasses: Record<ListingContainerBreakpoint, Record<ListingContainerCols, string>> = {
  default: {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6"
  },
  sm: {
    1: "sm:grid-cols-1",
    2: "sm:grid-cols-2",
    3: "sm:grid-cols-3",
    4: "sm:grid-cols-4",
    5: "sm:grid-cols-5",
    6: "sm:grid-cols-6"
  },
  md: {
    1: "md:grid-cols-1",
    2: "md:grid-cols-2",
    3: "md:grid-cols-3",
    4: "md:grid-cols-4",
    5: "md:grid-cols-5",
    6: "md:grid-cols-6"
  },
  lg: {
    1: "lg:grid-cols-1",
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
    5: "lg:grid-cols-5",
    6: "lg:grid-cols-6"
  },
  xl: {
    1: "xl:grid-cols-1",
    2: "xl:grid-cols-2",
    3: "xl:grid-cols-3",
    4: "xl:grid-cols-4",
    5: "xl:grid-cols-5",
    6: "xl:grid-cols-6"
  }
};
function getGridClasses(cols: ListingContainerResponsiveCols) {
  return (Object.entries(cols) as Array<[ListingContainerBreakpoint, ListingContainerCols]>).map(([bp, value]) => colClasses[bp][value]).join(" ");
}
export function ListingContainer(t0) {
  const $ = _c(19);
  const {
    list,
    renderCard,
    renderSkeleton,
    isLoading,
    className: t1,
    gapX: t2,
    gapY: t3,
    cols: t4,
    getKey,
    banners,
    emptyState,
    shouldAnimate: t5,
    animationStartIndex: t6
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const gapX = t2 === undefined ? "4" : t2;
  const gapY = t3 === undefined ? "6" : t3;
  let t7;
  if ($[0] !== t4) {
    t7 = t4 === undefined ? {
      default: 1,
      sm: 2,
      md: 2,
      lg: 3,
      xl: 4
    } : t4;
    $[0] = t4;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const cols = t7;
  const shouldAnimate = t5 === undefined ? true : t5;
  const animationStartIndex = t6 === undefined ? 0 : t6;
  const emptyStateProps = !isLoading && list.length === 0 ? emptyState : null;
  let t8;
  if ($[2] !== getKey) {
    t8 = (item, index) => {
      const key = getKey(item);
      return {
        staggerKey: `item-${String(key)}`,
        index,
        item,
        key
      };
    };
    $[2] = getKey;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const listItems = list.map(t8);
  const skeletonItems = isLoading ? Array.from({
    length: SKELETON_ITEMS_COUNT
  }).map((_, index_0) => ({
    index: index_0,
    staggerIndex: listItems.length + index_0,
    staggerKey: `skeleton-${index_0}`
  })) : [];
  const {
    getItemStaggerProperties
  } = useItemStagger([...listItems, ...skeletonItems].map(_temp));
  let t9;
  if ($[4] !== cols) {
    t9 = getGridClasses(cols);
    $[4] = cols;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const t10 = `grid ${t9} ${GAP_X[gapX]} ${GAP_Y[gapY]} ${className}`;
  let t11;
  if ($[6] !== emptyStateProps) {
    t11 = emptyStateProps && <ListingEmptyState {...emptyStateProps} />;
    $[6] = emptyStateProps;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== animationStartIndex || $[9] !== banners || $[10] !== getItemStaggerProperties || $[11] !== renderCard || $[12] !== shouldAnimate) {
    t12 = t13 => {
      const {
        index: index_1,
        item: item_0,
        key: key_0,
        staggerKey: staggerKey_0
      } = t13;
      return <Fragment key={`item-${String(key_0)}`}><ListingBanners banners={banners} index={index_1} /><div {...shouldAnimate && index_1 >= animationStartIndex ? getItemStaggerProperties(staggerKey_0, index_1) : {
          className: "h-full min-w-0"
        }}>{renderCard(item_0, index_1)}</div></Fragment>;
    };
    $[8] = animationStartIndex;
    $[9] = banners;
    $[10] = getItemStaggerProperties;
    $[11] = renderCard;
    $[12] = shouldAnimate;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = listItems.map(t12);
  const t15 = skeletonItems.map(t14 => {
    const {
      index: index_2,
      staggerIndex,
      staggerKey: staggerKey_1
    } = t14;
    return <div key={staggerKey_1} {...shouldAnimate && staggerIndex >= animationStartIndex ? getItemStaggerProperties(staggerKey_1, staggerIndex) : {
      className: "h-full min-w-0"
    }}>{renderSkeleton(index_2)}</div>;
  });
  let t16;
  if ($[14] !== t10 || $[15] !== t11 || $[16] !== t13 || $[17] !== t15) {
    t16 = <section className={t10}>{t11}{t13}{t15}</section>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t13;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  return t16;
}
function _temp(t0) {
  const {
    staggerKey
  } = t0;
  return staggerKey;
}